function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "318E0F3A-55D6-4BF3-A34D-B36EA145B3A2");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "SRX_Devicedemo_page_desktop",
  transform: "translate(-1062.000000, -1067.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "cameraview_controls",
  transform: "translate(1030.000000, 1067.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(32.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fillOpacity: 0.3,
  fill: "#000000",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.8567531,10.0215336 L22.6762582,17.7294621 C23.3073603,18.7387961 22.9876045,20.0605472 21.9620635,20.6816758 C21.6184248,20.8898038 21.2228455,21 20.819352,21 L11.1803418,21 C9.97617227,21 9,20.0392545 9,18.854115 C9,18.456998 9.11196563,18.0676701 9.32343557,17.7294621 L14.1429407,10.0215336 C14.7740428,9.01219963 16.1170174,8.69749699 17.1425584,9.3186256 C17.4332425,9.49468119 17.6778706,9.73544327 17.8567531,10.0215336 Z",
  id: "Triangle",
  fill: "#FFFFFF"
})))));

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.9651d1e6.svg";
export { ForwardRef as ReactComponent };